import React, { useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
const UpdateUserProfileModal = ({ initialData = {}, onSuccess }) => {
  const { userId } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    firstName: "",
    email: "",
    postalCode:"",
    address: "",
    city: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState(""); // ✅ Eigene State-Variable für Fehler

  const fetchUserData = async () => {
    try {
      const res = await fetch(
        "https://www.denisbitter.de/stage01/api/get_user_profile.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(userId) }), // id als Zahl senden
        }
      );

      const data = await res.json();
      console.log("API response:", data);

      if (data.success) {
        setFormData(data.data);
        setError(""); // Fehler zurücksetzen
      } else {
        setError("Fehler beim Laden der Daten: " + data.message);
      }
    } catch (err) {
      // 1. Fehlerhaften JSX-Code aus dem catch-Block entfernt
      setError("Fehler beim Laden der Daten.");
      console.error(err);
    }
  };



  // Button beenden einblenden 

  const [isSaved, setIsSaved] = useState(false);


  // Beim Öffnen des Modals Nutzerdaten laden
  useEffect(() => {
    if (isOpen) {
      fetchUserData();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    try {
      console.log("Sende Anfrage mit userId:", userId);
      const res = await fetch(
        "https://www.denisbitter.de/stage01/api/update_user_profile.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, id: Number(userId) }), // id statt userId senden
        }
      );

      const data = await res.json();
          if (data.success) {
            setError(""); // Fehler zurücksetzen
            setMessage(data.message || "Aktualisiert.");
            setIsSaved(true); // Speichern erfolgreich

            if (onSuccess) onSuccess();

            // Optional automatisch schließen:
            setTimeout(() => {
              setIsOpen(false);
              setMessage(""); // Nachricht nach dem Schließen zurücksetzen
            }, 1500);
          } else {
            setError(data.message || "Fehler beim Speichern.");
          }
    } catch (err) {
      setError("Fehler beim Speichern.");
      console.error(err);
    }
  };

  return (
    <>
      <div className="text-left">
        <button
          className="text-xs text-[#AC8E66]/80 hover:text-[#AC8E66] font-mono cursor-pointer transition-colors"
          onClick={() => setIsOpen(true)}
        >
          [settings →]
        </button>
      </div>
      {isOpen && (
        <div className="fixed inset-0 bg-[#121212]/95 backdrop-blur-sm flex items-center justify-center z-50" onClick={() => setIsOpen(false)}>
          <div className="w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40">
              {/* Title Bar */}
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
                <span className="w-3 h-3 rounded-full bg-[#ff5f57] cursor-pointer" onClick={() => setIsOpen(false)} />
                <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
                <span className="w-3 h-3 rounded-full bg-[#28c840]" />
                <span className="ml-3 text-xs text-[#AC8E66] select-none">settings</span>
              </div>

              <div className="px-5 sm:px-6 py-5 bg-[#151515] font-mono">
                <p className="text-sm text-[#EFEBDC]/50 mb-4">
                  <span className="text-[#AC8E66]">$</span> user --edit
                </p>

                <div className="space-y-3">
                  {[
                    { name: "firstName", value: formData.firstName, placeholder: "vorname", type: "text" },
                    { name: "name", value: formData.name, placeholder: "nachname", type: "text" },
                    { name: "address", value: formData.address, placeholder: "strasse", type: "text" },
                    { name: "postalcode", value: formData.postalCode, placeholder: "plz", type: "text" },
                    { name: "city", value: formData.city, placeholder: "stadt", type: "text" },
                    { name: "email", value: formData.email, placeholder: "email", type: "email" },
                  ].map((field) => (
                    <div key={field.name}>
                      <label className="text-[10px] text-[#EFEBDC]/30 uppercase tracking-wider mb-1 block">{field.placeholder}</label>
                      <input
                        type={field.type}
                        name={field.name}
                        value={field.value}
                        onChange={handleChange}
                        placeholder={field.placeholder}
                        className="w-full bg-[#1c1c1c] border border-[#AC8E66]/20 rounded px-3 py-2 text-xs text-[#EFEBDC] placeholder-[#EFEBDC]/20 font-mono focus:outline-none focus:border-[#AC8E66]/50 transition-colors"
                      />
                    </div>
                  ))}
                </div>

                <button
                  onClick={handleSave}
                  className="w-full mt-4 py-2.5 text-xs font-mono text-[#AC8E66] bg-[#1c1c1c] border border-[#AC8E66]/30 rounded hover:border-[#AC8E66]/60 hover:bg-[#1e1e1e] transition-all cursor-pointer"
                >
                  [ speichern → ]
                </button>

                {message && (
                  <p className="text-xs text-green-400/70 mt-2">
                    <span className="text-[#AC8E66]/80">&gt;</span> {message}
                  </p>
                )}
                {error && (
                  <p className="text-xs text-red-400/80 mt-2">
                    <span className="text-red-400/60">&gt;</span> {error}
                  </p>
                )}

                <button
                  className="mt-3 text-xs text-[#EFEBDC]/30 hover:text-[#EFEBDC]/60 font-mono w-full text-center cursor-pointer transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  [ abbrechen ]
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateUserProfileModal;
